module.exports = __webpack_public_path__ + "img/modele2_bg_2.a2583111.png";